import { configureStore } from '@reduxjs/toolkit'
import persistState from 'redux-localstorage'

import appProfile from './app-profile'
import applicationCycle from './application-cycle'
import careerTitles from './career-titles'
import collapseExpandedProspect from './collapse-expanded-prospect'
import collegeCompare from './college-compare'
import collegeGuidanceNetwork from './college-guidance-network'
import contentTags from './content-tags'
import features from './feature-toggle'
import inviters from './inviters'
import messaging from './messaging'
import microsurvey from './microsurvey'
import suggestionReasons from './suggestion-reasons'
import myMatchesMessaging from './my-matches-messaging'
import outreachMessaging from './outreach-messaging'
import parents from './parents'
import prospects from './prospects'
import savedCareerSearch from './saved-career-search'
import savedPublicCollegeSearch from './saved-public-college-search'
import savedSearch from './saved-search'
import snackbar from './snackbar'
import user from './user'

export default configureStore({
  reducer: {
    applicationCycle,
    collapseExpandedProspect,
    user,
    snackbar,
    messaging,
    outreachMessaging,
    features,
    parents,
    prospects,
    savedSearch,
    savedPublicCollegeSearch,
    microsurvey,
    suggestionReasons,
    savedCareerSearch,
    collegeCompare,
    appProfile,
    contentTags,
    careerTitles,
    inviters,
    myMatchesMessaging,
    collegeGuidanceNetwork,
  },
  enhancers: [persistState(['collegeCompare', 'savedPublicCollegeSearch'], { key: 'scoir-student-redux-state' })],
})
